export default {
    API_URL: process.env.REACT_APP_SERVER_URL,
    MAIL_TEMPLATE: process.env.REACT_APP_Template,
    SERVICE_ID : process.env.REACT_APP_ServiceId,
    MAIL_USER_ID: process.env.REACT_APP_USERID,
}